import script from "./ContestImageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestImageDetail.vue?vue&type=script&setup=true&lang=js"

import "./ContestImageDetail.vue?vue&type=style&index=0&id=b7d6d12c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7d6d12c"]])

export default __exports__